import React, { FC } from 'react';
import {
    GetFilteredYards_getFilteredYards as Yard,
    GetAllRegions_getAllRegions as RegionType
} from '../../types/schemaTypes';
import { useLazyLoading } from '../_common';
import { Option } from './interface';
import YardItem from './YardItem';
import './Yards.scss';

interface YardListProps {
    yards: Yard[];
    regionsWithDistricts: RegionType[];
    canEditYards: boolean;
    canDeleteYards: boolean;
    isLoading: boolean;
    isEndOfResults: boolean;
    onEditClick: (Lofa: Yard) => void;
    onLoadMore: () => void;
    onDelete?: (record: any) => void;
    onClickYard: (lat: number, lng: number, yardName: string) => void;
}

const YardList: FC<YardListProps> = ({
    yards,
    regionsWithDistricts,
    isLoading,
    isEndOfResults,
    onEditClick,
    canEditYards,
    canDeleteYards,
    onLoadMore,
    onDelete,
    onClickYard,
}: YardListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('lofaList', isLoading, isEndOfResults, onLoadMore);

    return (
        <div className="Lofas-List" onScroll={handleScroll}>
            {
                yards.map((yard, index) => (
                    <YardItem
                        key={yard.id ? yard.id.toString() : '0'}
                        index={index}
                        yard={yard}
                        regionsWithDistricts={regionsWithDistricts}
                        canEditYards={canEditYards}
                        canDeleteYards={canDeleteYards}
                        onEditClick={onEditClick}
                        onDelete={onDelete}
                        onClickYard={onClickYard}
                    />
                ))
            }
        </div>
    );
};

export default YardList;

